"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.CheckboxComponent = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _forms = require("@morpheus-ui/forms");

var _transitionClass = _interopRequireDefault(require("../transitionClass"));

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  padding: 2px 0;\n  margin-bottom: 2px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  margin-left: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  color: ", ";\n\n  ", "\n\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  opacity: 0;\n  width: ", ";\n  height: ", ";\n  color: ", ";\n\n\n    ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  padding: 1px;\n  border-width: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n\n  \n  ", "\n\n    ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: ", ";\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SvgCheckSymbol = function SvgCheckSymbol(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "11",
    height: "7",
    viewBox: "0 0 11 7"
  }, props), _react.default.createElement("path", {
    d: "M9.422.146L4 5.568.853 2.422a.5.5 0 0 0-.707.707l3.5 3.5a.498.498 0 0 0 .707 0L10.13.853a.5.5 0 0 0-.707-.707z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var OutterContainer = _native.default.View(_templateObject());

var Container = _native.default.View(_templateObject2());

var Touchable = _native.default.TouchableWithoutFeedback(_templateObject3());

var InnerContainer = _native.default.View(_templateObject4(), function (props) {
  return props.muitheme.margin;
});

var CheckboxContainer = _native.default.View(_templateObject5(), function (props) {
  return props.muitheme.backgroundColor;
}, function (props) {
  return props.muitheme.containerBorderWidth;
}, function (props) {
  return props.muitheme.containerBorderColor;
}, function (props) {
  return props.muitheme.containerBorderRadius;
}, function (props) {
  return !props.value && props.muitheme.containerShadow && "\n    shadow-color: #000;\n    shadow-offset: {width: 0, height: 0};\n    shadow-opacity: 0.1;\n    shadow-radius: 8;\n  ";
}, function (props) {
  return props.value && props.muitheme.containerCheckedShadow && "\n    shadow-color: #000;\n    shadow-offset: {width: 0, height: 0};\n    shadow-opacity: 0.1;\n    shadow-radius: 8;\n  ";
}, function (props) {
  return props.value && "background-color: " + props.muitheme.backgroundCheckedColor + ";\n     border-width: " + props.muitheme.containerCheckedBorderWidth + ";\n     border-color: " + props.muitheme.containerCheckedBorderColor + ";\n    ";
}, function (props) {
  return props.disabled && "background-color: " + props.muitheme.backgroundDisabledColor + ";";
});

var CheckSymbol = _native.default.Text(_templateObject6(), function (props) {
  return props.muitheme.checkSymbolSize;
}, function (props) {
  return props.muitheme.checkSymbolSize;
}, function (props) {
  return props.muitheme.checkSymbolColor;
}, function (props) {
  return props.value && props.muitheme.checkSymbolCheckedShadow && "\n    shadow-color: #000;\n    shadow-offset: {width: 0, height: 0};\n    shadow-opacity: 0.1;\n    shadow-radius: 8;\n  ";
}, function (props) {
  return props.value && "opacity: 1;";
}, function (props) {
  return props.disabled && "color: " + props.muitheme.checkSymbolDisabledColor + ";";
});

var Label = _native.default.Text(_templateObject7(), function (props) {
  return props.muitheme.fontFamily;
}, function (props) {
  return props.muitheme.labelMargin;
}, function (props) {
  return props.muitheme.fontSize;
}, function (props) {
  return props.muitheme.fontWeight;
}, function (props) {
  return props.muitheme.fontStyle;
}, function (props) {
  return props.muitheme.labelColor;
}, function (props) {
  return props.value && "color: " + props.muitheme.labelCheckedColor + ";";
}, function (props) {
  return props.disabled && "color: " + props.muitheme.labelDisabledColor + ";";
});

var ErrorMessage = _native.default.Text(_templateObject8(), function (props) {
  return props.muitheme.fontFamily;
}, function (props) {
  return props.muitheme.errorFontSize;
}, function (props) {
  return props.muitheme.errorColor;
});

var CheckboxComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(CheckboxComponent, _Component);

  function CheckboxComponent(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getCheckboxTheme", (0, _memoizeOne.default)(function (props, context) {
      return (0, _ThemeProvider.getTheme)('Checkbox', props, context);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onPress", function () {
      if (!_this.props.disabled) {
        var value = _this.getValue();

        _this.props.onChange && _this.props.onChange(!value);
        !_this.props.dirty && _this.props.setDirty && _this.props.setDirty();

        if (!_this.props.inForm) {
          _this.setState({
            value: !value
          });
        }
      }
    });
    _this.state = {
      value: !!_props.defaultValue || false
    };
    return _this;
  }

  var _proto = CheckboxComponent.prototype;

  _proto.getValue = function getValue() {
    var _this$props = this.props,
        inForm = _this$props.inForm,
        defaultValue = _this$props.defaultValue,
        value = _this$props.value,
        fieldValue = _this$props.fieldValue;

    if (inForm) {
      return fieldValue != null ? fieldValue : defaultValue || false;
    }

    if (value != null) {
      return value || defaultValue || false;
    }

    return this.state.value;
  };

  _proto.render = function render() {
    var muitheme = this.getCheckboxTheme(this.props, this.context);
    var value = this.getValue();
    var showError = (this.props.isSubmitted() || this.props.dirty) && !!this.props.errorMessage;
    return _react.default.createElement(OutterContainer, null, _react.default.createElement(Container, null, _react.default.createElement(Touchable, {
      disabled: this.props.disabled,
      onPress: this.onPress
    }, _react.default.createElement(InnerContainer, {
      muitheme: muitheme
    }, _react.default.createElement(CheckboxContainer, {
      disabled: this.props.disabled,
      muitheme: muitheme,
      className: _transitionClass.default,
      value: value
    }, _react.default.createElement(CheckSymbol, {
      disabled: this.props.disabled,
      muitheme: muitheme,
      className: _transitionClass.default,
      value: value
    }, _react.default.createElement(SvgCheckSymbol, null))), (this.props.checkedLabel || this.props.label) && _react.default.createElement(Label, {
      disabled: this.props.disabled,
      muitheme: muitheme,
      className: _transitionClass.default,
      value: value
    }, value ? this.props.checkedLabel || this.props.label : this.props.label))), _react.default.createElement(ErrorMessage, {
      muitheme: muitheme
    }, showError ? this.props.errorMessage : '')));
  };

  return CheckboxComponent;
}(_react.Component);

exports.CheckboxComponent = CheckboxComponent;
(0, _defineProperty2.default)(CheckboxComponent, "contextType", _ThemeProvider.default);

var _default = (0, _forms.turnIntoField)(CheckboxComponent);

exports.default = _default;